<template>
    <v-card>
        <v-card-text>
            <v-card-title primary-title>
                <div>
                    <h3 class="headline mb-0">Información Personal</h3>
                    <span class="grey--text">{{datosPersonales.fechaActualizacion}}</span>
                </div>
            </v-card-title>
            <v-form v-model="valid" v-if="!loadingDatosPersonales">
                <v-container fluid grid-list-md>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-text-field
                                    v-model="datosPersonales.curp"
                                    :rules="rules.curp"
                                    :counter="18"
                                    label="CURP"
                                    required
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field
                                    v-model="datosPersonales.email"
                                    :rules="rules.email"
                                    label="Correo Electrónico"
                                    required
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md4>
                            <v-autocomplete
                                    :items="estados"
                                    v-model="datosPersonales.lugarNacimiento"
                                    :rules="[() => datosPersonales.lugarNacimiento > 0 || 'Debes de saleccionar un estado']"
                                    item-value="id"
                                    item-text="nombre"
                                    label="Lugar de Nacimiento"
                                    required
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-dialog
                                    ref="dialog"
                                    v-model="modal"
                                    :return-value.sync="datosPersonales.fechaNacimiento"
                                    persistent
                                    lazy
                                    full-width
                                    width="290px"
                            >
                                <v-text-field
                                        slot="activator"
                                        v-model="datosPersonales.fechaNacimiento"
                                        label="Fecha de nacimiento"
                                        prepend-icon="event"
                                        readonly
                                ></v-text-field>
                                <v-date-picker v-model="datosPersonales.fechaNacimiento" scrollable locale="es-mx">
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="modal = false">Cancelar</v-btn>
                                    <v-btn flat color="primary" @click="$refs.dialog.save(datosPersonales.fechaNacimiento)">
                                        Aceptar
                                    </v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-select
                                    :items="generos"
                                    v-model="datosPersonales.genero"
                                    item-value="id"
                                    label="Género"
                            ></v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md4>
                            <v-select
                                    :items="gruposSanguineos"
                                    v-model="datosPersonales.tipoSangre"
                                    :rules="rules.gruposSanguineos"
                                    item-value="id"
                                    label="Tipo de Sangre"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-select
                                    :items="estadosCiviles"
                                    v-model="datosPersonales.estadoCivil"
                                    item-value="id"
                                    label="Estado Civil"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field
                                    v-model="datosPersonales.telefono"
                                    :mask="'phone'"
                                    label="Teléfono Domicilio"
                                    required
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-flex xs12 md12>
                        <v-text-field
                                v-model="datosPersonales.domicilio"
                                :rules="rules.domicilio"
                                label="Domicilio"
                                required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md12>
                        <v-text-field
                                v-model="datosPersonales.colonia"
                                :rules="rules.colonia"
                                label="Colonia"
                                required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md12>
                        <v-text-field
                                v-model="datosPersonales.ciudad"
                                :rules="rules.ciudad"
                                label="Ciudad"
                                required
                                autocomplete="nope"
                        ></v-text-field>
                    </v-flex>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-text-field
                                    v-model="datosPersonales.codigoPostal"
                                    :rules="rules.codigoPostal"
                                    label="Código Postal"
                                    required
                                    type="number"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-autocomplete
                                    :items="estados"
                                    v-model="datosPersonales.estado"
                                    :rules="[() => datosPersonales.estado > 0 || 'Debes de saleccionar un estado']"
                                    item-value="id"
                                    item-text="nombre"
                                    label="Estado"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <v-subheader class="pl-0 black--text">Otros datos</v-subheader>
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-autocomplete
                                    :items="discapacidades"
                                    v-model="datosPersonales.discapacidad"
                                    label="¿Presentas alguna discapacidad?"
                                    item-value="id"
                                    item-text="text"
                                    autocomplete="nope"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-autocomplete
                                    :items="riesgosAbandono"
                                    v-model="datosPersonales.riesgoAbandono"
                                    label="¿Te encuentras en riesgo de abandono escolar? Selecciona una causa"
                                    item-value="id"
                                    item-text="text"
                                    autocomplete="nope"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <v-subheader class="pl-0 black--text">¿Perteneces a alguna comunidad indígena o afrodescendiente?</v-subheader>
                    <v-layout>
                        <v-flex xs12 md4>
                            <v-autocomplete
                                    :items="respuestaComunidadIndigena"
                                    v-model="datosPersonales.pertenecesComunidadIndigena"
                                    label=""
                                    item-value="id"
                                    item-text="text"
                                    autocomplete="nope"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field
                                    v-model="datosPersonales.comunidadIndigena"
                                    label="Comunidad Indígena"
                                    autocomplete="nope"
                                    :disabled="datosPersonales.pertenecesComunidadIndigena === 0"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field
                                    v-model="datosPersonales.lenguaIndigena"
                                    label="Lengua Indígena"
                                    :disabled="datosPersonales.pertenecesComunidadIndigena === 0"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-subheader class="pl-0 black--text">Datos de emergencia</v-subheader>
                    <v-layout row wrap>
                        <v-flex xs12 md8>
                            <v-text-field
                                    v-model="datosPersonales.contactoEmergencia"
                                    label="Nombre"
                                    required
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field
                                    v-model="datosPersonales.telefonoEmergencia"
                                    label="Teléfono"
                                    :mask="'phone'"
                                    required
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
            <v-progress-linear :indeterminate="true" v-else="loadingDatosPersonales"></v-progress-linear>
        </v-card-text>
        <v-divider class="mt-5"></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                    color="primary"
                    flat
                    @click="guardar"
                    :loading="guardarLoading"
                    :disabled="guardarLoading || !valid"
            >Guardar</v-btn>
        </v-card-actions>
        <v-snackbar
                :color="'success'"
                :top="'top'"
                :right="true"
                v-model="snackbar"
        >
            {{ snackbarMensaje }}
            <v-btn flat @click.native="snackbar = false">Cerrar</v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
  import axios from 'axios'
  import * as moment from 'moment'
  import { mapState } from 'vuex'
  import { FETCH_CATALOGO_ESTADOS } from '@/store/mutation-types'
  import validator from 'validator'

  export default {
    name: 'PersonalData',
    created () {
      this.getEstados()
      this.loadDatosPersonales()
    },
    data: () => ({
      valid: false,
      modal: false,
      loadingDatosPersonales: false,
      guardarLoading: false,
      datosPersonales: {},
      rules: {
        curp: [
          v => !!v || 'La CURP es requerida',
          v => (v && v.length <= 18) || 'Tiene un tamaño de 18 caracteres'
        ],
        email: [
          v => !!v || 'El correo electrónico es necesario',
          v => validator.isEmail(v) || 'Debes de introducir un correo electrónico válido'
        ],
        domicilio: [
          v => !!v || 'Es necesario ingreses tu dirección'
        ],
        colonia: [
          v => !!v || 'Es necesario ingreses tu colonia'
        ],
        ciudad: [
          v => !!v || 'Es necesario ingreses tu ciudad'
        ],
        codigoPostal: [
          v => !!v || 'Es necesario ingreses tu código postal'
        ],
        gruposSanguineos: [
          v => !!v || 'Debes de saleccionar un estado'
        ]
      },
      generos: [
        {id: 'M', text: 'Masculino'},
        {id: 'F', text: 'Femenino'}
      ],
      gruposSanguineos: [
        {id: 'A -', text: 'A -'},
        {id: 'A +', text: 'A +'},
        {id: 'B -', text: 'B -'},
        {id: 'B +', text: 'B +'},
        {id: 'AB -', text: 'AB -'},
        {id: 'AB +', text: 'AB +'},
        {id: 'O -', text: 'O -'},
        {id: 'O +', text: 'O +'}
      ],
      estadosCiviles: [
        {id: 'S', text: 'Soltero(a)'},
        {id: 'C', text: 'Casado(a)'},
        {id: 'D', text: 'Divorsiado(a)'},
        {id: 'V', text: 'Viudo(a)'},
        {id: 'U', text: 'Unión Libre'},
        {id: 'O', text: 'Otro'}
      ],
      discapacidades: [
        {id: 0, text: 'Ninguna'},
        {id: 1, text: 'Discapacidad sensorial y de comunicación'},
        {id: 2, text: 'Discapacidad motriz'},
        {id: 3, text: 'Discapacidad mental'},
        {id: 4, text: 'Discapacidades múltiples'}
      ],
      respuestaComunidadIndigena: [
        {id: 0, text: 'No'},
        {id: 1, text: 'Sí'}
      ],
      riesgosAbandono: [
        {id: 0, text: 'Ninguno'},
        {id: 1, text: 'Familiar'},
        {id: 2, text: 'Económico'},
        {id: 3, text: 'Académico'},
        {id: 4, text: 'Social'}
      ],
      snackbar: false,
      snackbarMensaje: ''
    }),
    watch: {
      pertenecesComunidadIndigena (value) {
        if (value === 0) {
          this.datosPersonales.comunidadIndigena = ''
          this.datosPersonales.lenguaIndigena = ''
        }
      }
    },
    computed: {
      ...mapState({
        estados: state => state.catalogs.listaEstados
      }),
      pertenecesComunidadIndigena () {
        return this.datosPersonales.pertenecesComunidadIndigena
      }
    },
    methods: {
      getEstados () {
        this.$store.dispatch(FETCH_CATALOGO_ESTADOS)
      },
      loadDatosPersonales () {
        this.loadingDatosPersonales = true
        axios.get('alumno/datos-personales')
          .then(resp => {
            this.loadingDatosPersonales = false
            moment.locale('es')
            const fechaActualizacion = resp.data.datosPersonales.fechaActualizacion ? moment(resp.data.datosPersonales.fechaActualizacion).format('LLLL') : ''

            this.datosPersonales = resp.data.datosPersonales
            this.datosPersonales.fechaActualizacion = fechaActualizacion
          })
          .catch(err => {
            this.loadingDatosPersonales = false
            console.log(err)
          })
      },
      guardar () {
        this.guardarLoading = true
        axios.put('alumno/datos-personales', this.datosPersonales)
          .then(resp => {
            this.guardarLoading = false
            this.snackbar = true
            this.snackbarMensaje = 'Los datos se han guardado correctamente.'
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/forms/PersonalData.vue